import { AnimatePresence } from 'framer-motion';
import { InfoScene } from './InfoScene';
import { ChoiceScene } from './ChoiceScene';
import { ChecklistScene } from './ChecklistScene';

export const SceneRenderer = ({ scene, onChoice, onChecklistComplete, onContinue }) => {
  if (!scene) return null;

  return (
    <AnimatePresence mode="wait">
      {scene.type === 'info' && (
        <InfoScene
          key={scene.id}
          scene={scene}
          onContinue={onContinue}
        />
      )}
      {scene.type === 'choice' && (
        <ChoiceScene
          key={scene.id}
          scene={scene}
          onChoice={onChoice}
          onContinue={onContinue}
        />
      )}
      {scene.type === 'checklist' && (
        <ChecklistScene
          key={scene.id}
          scene={scene}
          onComplete={onChecklistComplete}
          onContinue={onContinue}
        />
      )}
    </AnimatePresence>
  );
};
